"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _Spacer = require("./Spacer.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Spacer = function Spacer(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '0px' : _ref$value,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-spacer' : _ref$dataTestId;
  var isLocal;

  if (typeof window !== 'undefined') {
    isLocal = window.location.origin.includes('localhost');
  } else {
    isLocal = false;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_Spacer.Occ_Spacer, {
    "data-test-id": dataTestId,
    direction: direction,
    value: value,
    isLocal: isLocal,
    "aria-hidden": "true"
  }));
};

var _default = Spacer;
exports["default"] = _default;